import { Injectable } from '@angular/core';
import API_URL from '../../utils/api-url-homolog';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { UserExtraLayer } from '../../entities/user.entity';

@Injectable({
  providedIn: 'root'
})
export class ExtraLayerService {

  constructor(
    private readonly http: HttpClient
  ) { }

  getExtraLayers(userId: number): Promise<UserExtraLayer[]> {
    return firstValueFrom(this.http.get<UserExtraLayer[]>(`${API_URL}/user/extralayers/${userId}`));
  }

  createExtraLayer(payload: {userId: number, name: string, url: string}): Promise<UserExtraLayer> {
    return firstValueFrom(this.http.post<UserExtraLayer>(`${API_URL}/user/extralayers/create`, payload));
  }

  deleteExtraLayer(extraLayerId: number): Promise<void> {
    return firstValueFrom(this.http.delete<void>(`${API_URL}/user/extralayers/${extraLayerId}`));
  }
}
